/** A late geocode result is only usable if the address still matches its request. */
export function isCurrentGeocodeAddress(requestedAddress: string, currentAddress: string): boolean {
  return requestedAddress.trim() === currentAddress.trim();
}
